var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenewOffice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.998,
    height: 99.998,
    viewBox: "0 0 99.998 99.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10286",
    "data-name": "Group 10286",
    transform: "translate(2660.499 19487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Certificate_-_Free_real_estate_icons-2",
    "data-name": "Certificate - Free real estate icons-2",
    transform: "translate(-2635.91 -19470.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10283",
    "data-name": "Group 10283",
    transform: "translate(0 8.533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1_39_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_40---Certificate"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_91_",
    d: "M47.431,8.533H3.388A3.4,3.4,0,0,0,0,11.936V48.514a3.4,3.4,0,0,0,3.388,3.4h6.776V56.17a1.7,1.7,0,0,0,1.694,1.7,1.668,1.668,0,0,0,.869-.242L15.246,56.1l2.517,1.521a1.694,1.694,0,0,0,2.565-1.456V51.917h27.1a3.4,3.4,0,0,0,3.388-3.4V11.936a3.4,3.4,0,0,0-3.388-3.4ZM8.853,41.815a4.7,4.7,0,0,0-1.191-1.5c-.415-.395-.886-.85-.886-1.16s.471-.766.886-1.16a4.7,4.7,0,0,0,1.191-1.5,4.908,4.908,0,0,0,.23-1.964c-.009-.533-.022-1.2.174-1.393s.858-.185,1.387-.175a4.845,4.845,0,0,0,1.955-.231,4.663,4.663,0,0,0,1.493-1.2c.4-.416.846-.889,1.154-.889s.758.473,1.154.889a4.66,4.66,0,0,0,1.493,1.2,4.854,4.854,0,0,0,1.955.231c.527-.008,1.193-.021,1.387.175s.183.859.169,1.393a4.908,4.908,0,0,0,.23,1.964A4.7,4.7,0,0,0,22.825,38c.419.395.89.85.89,1.16s-.471.766-.886,1.16a4.7,4.7,0,0,0-1.191,1.5,4.908,4.908,0,0,0-.23,1.964c.009.533.022,1.2-.169,1.393s-.858.184-1.387.175h-.379a4.012,4.012,0,0,0-1.576.234,4.663,4.663,0,0,0-1.493,1.2c-.4.413-.85.886-1.159.886s-.758-.473-1.154-.889a4.66,4.66,0,0,0-1.493-1.2,3.957,3.957,0,0,0-1.535-.236H11c-.12,0-.24,0-.36,0-.526.01-1.192.021-1.387-.175s-.183-.859-.174-1.393A4.908,4.908,0,0,0,8.853,41.815Zm6.83,12.569a.844.844,0,0,0-.874,0L11.858,56.17V47.125a.856.856,0,0,1,.092.025,3.665,3.665,0,0,1,.916.8,3.487,3.487,0,0,0,2.38,1.416,3.487,3.487,0,0,0,2.38-1.416,3.665,3.665,0,0,1,.916-.8c.026-.011.063-.016.092-.026v9.045Zm33.443-5.87a1.7,1.7,0,0,1-1.694,1.7h-27.1V47.052a2.847,2.847,0,0,0,2.1-.681,3.424,3.424,0,0,0,.67-2.626,3.861,3.861,0,0,1,.1-1.281,3.681,3.681,0,0,1,.8-.92,3.508,3.508,0,0,0,1.41-2.387A3.508,3.508,0,0,0,24,36.767a3.683,3.683,0,0,1-.8-.92,3.861,3.861,0,0,1-.1-1.281,3.424,3.424,0,0,0-.67-2.626,3.39,3.39,0,0,0-2.615-.673,3.786,3.786,0,0,1-1.276-.1,3.665,3.665,0,0,1-.916-.8,3.487,3.487,0,0,0-2.38-1.416,3.487,3.487,0,0,0-2.38,1.416,3.665,3.665,0,0,1-.916.8,3.854,3.854,0,0,1-1.276.1,3.4,3.4,0,0,0-2.615.673,3.424,3.424,0,0,0-.67,2.624,3.861,3.861,0,0,1-.1,1.281,3.681,3.681,0,0,1-.8.92,3.508,3.508,0,0,0-1.41,2.392,3.508,3.508,0,0,0,1.41,2.39,3.684,3.684,0,0,1,.792.92,3.861,3.861,0,0,1,.1,1.281,3.424,3.424,0,0,0,.67,2.626,2.844,2.844,0,0,0,2.1.681v3.16H3.388a1.7,1.7,0,0,1-1.694-1.7V11.936a1.7,1.7,0,0,1,1.694-1.7H47.431a1.7,1.7,0,0,1,1.694,1.7Z",
    transform: "translate(0 -8.533)",
    fill: "#286c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_90_",
    d: "M107.5,274.741a5.1,5.1,0,1,0-5.1-5.1A5.1,5.1,0,0,0,107.5,274.741Zm0-8.507a3.4,3.4,0,1,1-3.4,3.4A3.4,3.4,0,0,1,107.5,266.234Z",
    transform: "translate(-92.247 -239.013)",
    fill: "#286c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_89_",
    d: "M283.25,100.885V96.4a1.7,1.7,0,0,0-1.7-1.7h-1.7a1.7,1.7,0,0,0-1.692,1.608l-2.237-2.01a1.757,1.757,0,0,0-2.35,0l-8.459,7.6a1.708,1.708,0,0,0-.458,1.894,1.729,1.729,0,0,0,1.586,1.11v8.514a1.7,1.7,0,0,0,1.7,1.7h13.611a1.7,1.7,0,0,0,1.7-1.7V104.9a1.728,1.728,0,0,0,1.586-1.106,1.707,1.707,0,0,0-.459-1.894Zm-3.4-4.484h1.7v2.955l-1.7-1.531Zm-5.066-.838,8.42,7.643h-8.458l-8.5-.044Zm-.889,17.851v-2.552a.851.851,0,1,1,1.7,0v2.552Zm3.4,0v-2.552a2.552,2.552,0,1,0-5.1,0v2.552h-4.253v-8.507h13.611v8.507Z",
    transform: "translate(-238.385 -85.342)",
    fill: "#286c4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10282",
    "data-name": "Group 10282",
    transform: "translate(3.403 3.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101_",
    d: "M84.43,136.533H69.118a.851.851,0,1,0,0,1.7H84.43a.851.851,0,0,0,0-1.7Z",
    transform: "translate(-64.864 -127.176)",
    fill: "#286c4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100_",
    d: "M84.43,179.2H69.118a.851.851,0,1,0,0,1.7H84.43a.851.851,0,0,0,0-1.7Z",
    transform: "translate(-64.864 -165.589)",
    fill: "#286c4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99_",
    d: "M221.841,94.718a.851.851,0,0,0-.851-.851h-6.805a.851.851,0,1,0,0,1.7h6.805A.851.851,0,0,0,221.841,94.718Z",
    transform: "translate(-195.592 -88.763)",
    fill: "#286c4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98_",
    d: "M180.051,52.9h13.611a.851.851,0,1,0,0-1.7H180.051a.851.851,0,0,0,0,1.7Z",
    transform: "translate(-164.864 -50.35)",
    fill: "#286c4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97_",
    d: "M38.387,43.518a.851.851,0,0,0-.851-.851H34.985a.851.851,0,0,0-.851.851V46.07a.851.851,0,0,0,1.7,0v-1.7h1.7A.851.851,0,0,0,38.387,43.518Z",
    transform: "translate(-34.134 -42.667)",
    fill: "#286c4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96_",
    d: "M304.6,332.8H290.985a.851.851,0,1,0,0,1.7H304.6a.851.851,0,0,0,0-1.7Z",
    transform: "translate(-264.835 -303.877)",
    fill: "#286c4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95_",
    d: "M304.6,375.467H290.985a.851.851,0,0,0,0,1.7H304.6a.851.851,0,0,0,0-1.7Z",
    transform: "translate(-264.835 -342.291)",
    fill: "#286c4d",
    fillRule: "evenodd"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Renew_-_Flaticon-2",
    "data-name": "Search results for Renew - Flaticon-2",
    transform: "translate(-2660.499 -19487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10284",
    "data-name": "Group 10284",
    transform: "translate(74.998 8.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9922",
    "data-name": "Path 9922",
    d: "M32.583,18.666h-12.5a2.083,2.083,0,0,1,0-4.167H30.5V4.083a2.083,2.083,0,1,1,4.167,0v12.5A2.084,2.084,0,0,1,32.583,18.666Z",
    transform: "translate(-18 -2)",
    fill: "#286c4d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10285",
    "data-name": "Group 10285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9923",
    "data-name": "Path 9923",
    d: "M50,100a50,50,0,1,1,40.22-79.6,2.084,2.084,0,1,1-3.362,2.462A45.756,45.756,0,1,0,95.831,50a41.589,41.589,0,0,0-.4-5.954,2.084,2.084,0,1,1,4.125-.592A45.572,45.572,0,0,1,100,50,50.055,50.055,0,0,1,50,100Z",
    fill: "#286c4d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewOffice);
export default __webpack_public_path__ + "static/media/renewOffice.9bee5053f2836fc38845dc1d6f64c724.svg";
export { ForwardRef as ReactComponent };